import * as actions from '../actions/taskSettingsActions';

const initialState = {
    settings: [],
    loading: false,
    error: null,
};

const taskSettingsReducer = (state = initialState, action) => {
    switch (action.type) {
        case actions.SET_TASK_SETTINGS_LOADING:
            return {
                ...state,
                loading: action.payload,
            };
        case actions.GET_TASK_SETTINGS_SUCCESS:
            return {
                ...state,
                settings: action.payload,
                error: null,
            };
        case actions.GET_TASK_SETTINGS_FAIL:
            return {
                ...state,
                error: action.error,
            };
        case actions.CREATE_TASK_SETTING_SUCCESS:
            return {
                ...state,
                settings: [...state.settings, action.payload],
                error: null,
            };
        case actions.CREATE_TASK_SETTING_FAIL:
            return {
                ...state,
                error: action.error,
            };
        case actions.UPDATE_TASK_SETTING_SUCCESS:
            return {
                ...state,
                settings: state.settings.map((setting) =>
                    setting.id === action.payload.id ? action.payload : setting
                ),
                error: null,
            };
        case actions.UPDATE_TASK_SETTING_FAIL:
            return {
                ...state,
                error: action.error,
            };
        case actions.DELETE_TASK_SETTING_SUCCESS:
            return {
                ...state,
                settings: state.settings.filter(
                    (setting) => setting.id !== action.payload.id
                ),
                error: null,
            };
        case actions.DELETE_TASK_SETTING_FAIL:
            return {
                ...state,
                error: action.error,
            };
        case actions.TOGGLE_TASK_SETTING_STATUS_SUCCESS:
            return {
                ...state,
                settings: state.settings.map((setting) =>
                    setting.id === action.payload.id ? action.payload : setting
                ),
                error: null,
            };
        case actions.TOGGLE_TASK_SETTING_STATUS_FAIL:
            return {
                ...state,
                error: action.error,
            };
        default:
            return state;
    }
};

export default taskSettingsReducer;
